import { CustomInputOptionList } from '../../type/common.type';

// 필수 필드 존재 여부 확인
export const hasRequiredFieldInCustomInputOptions = (customInputOptions: CustomInputOptionList[] = []) =>
  customInputOptions.filter((o) => o.is_required).length > 0;
